import { useState, useEffect } from "react";

import { Container, Content } from "./MainContainer.styles";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import PromoTickerBar from "../PromoTickerBar/PromoTickerBar";
import settingsService from "../../api/services/settings";

const TICKER_HEIGHT = 38;

const MainContainer = ({ children }) => {
  const [tickerVisible, setTickerVisible] = useState(true);
  const [promoTicker, setPromoTicker] = useState({ enabled: false, text: "" });

  // Podešavanja trake se uređuju u Admin Panelu → Podešavanja
  useEffect(() => {
    let mounted = true;

    settingsService
      .getPromoTickerCached()
      .then((ticker) => {
        if (mounted && ticker) setPromoTicker(ticker);
      })
      .catch(() => {
        // Traka nije kritična — u slučaju greške ostaje sakrivena
      });

    return () => {
      mounted = false;
    };
  }, []);

  const tickerEnabled =
    promoTicker.enabled && Boolean(promoTicker.text?.trim());

  useEffect(() => {
    if (!tickerEnabled) return;

    const handleScroll = () => {
      setTickerVisible(window.scrollY <= TICKER_HEIGHT);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [tickerEnabled]);

  return (
    <Container>
      {tickerEnabled && (
        <PromoTickerBar visible={tickerVisible} text={promoTicker.text} />
      )}
      <Header tickerVisible={tickerEnabled && tickerVisible} />
      <Content>{children}</Content>
      <Footer />
    </Container>
  );
};

export default MainContainer;
